import NetworkRequestConfiguration from '@root/core/src/networking/network-request-configuration';

export default function getBillingFeaturesContextConfiguration() {
  return new NetworkRequestConfiguration({
    endpoint: 'auto_renters/billing_features_context',
    method: NetworkRequestConfiguration.Methods.GET,
    errorCodes: [204],
  });
}
